import React from 'react';
type IconProps = {
  className?: string;
  strokeWidth?: number;
};
const base = (className?: string) => `shrink-0 ${className ?? 'w-6 h-6'}`;
const common = (strokeWidth?: number) => ({
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: strokeWidth ?? 1.4,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
  focusable: 'false' as const
});
export function MicIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-195" data-mp="2he11sdkevqbz">
      <rect x="9" y="2.5" width="6" height="11" rx="3" data-id="element-196" data-mp="2hcg6glq9w3d2" />
      <path d="M5.5 11a6.5 6.5 0 0 0 13 0" data-id="element-197" data-mp="2m6aq5p5voic5" />
      <path d="M12 17.5V21" data-id="element-198" data-mp="2m7lr7h7xvbzk" />
      <path d="M8.5 21h7" data-id="element-199" data-mp="2r4vqdol4r20l" />
    </svg>;
}
export function ClapperboardIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-200" data-mp="2w4qfpnp9bjjj">
      <path d="M3 9.5h18V19a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19V9.5Z" data-id="element-201" data-mp="304r4a162lb4b" />
      <path d="M3.6 9.5 3 6.1l17.4-2.6.6 3.4L3.6 9.5Z" data-id="element-202" data-mp="302o9l3tz2tt9" />
      <path d="m8.4 4.8 1.3 3.9" data-id="element-203" data-mp="gs839w6ctnh5" />
      <path d="m13.9 4 1.3 3.9" data-id="element-204" data-mp="gp3suh2apvi1" />
    </svg>;
}
export function PresentationIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-205" data-mp="6sr29s21rxri">
      <path d="M3 3.5h18" data-id="element-206" data-mp="6v3pokqkr0by" />
      <path d="M4.5 3.5v10.5h15V3.5" data-id="element-207" data-mp="1upgv0h5fmcv" />
      <path d="M12 14v3.5" data-id="element-208" data-mp="1vqsp75zocvn" />
      <path d="m8.5 21 3.5-3.5L15.5 21" data-id="element-209" data-mp="1wk2kh08vii0" />
      <path d="M8.5 10.5V8" data-id="element-210" data-mp="zi7p8a6wemgc" />
      <path d="M12 10.5V6.5" data-id="element-211" data-mp="zhes80xqrbbe" />
      <path d="M15.5 10.5v-1.7" data-id="element-212" data-mp="zjsmw8oielif" />
    </svg>;
}
export function RadioIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-213" data-mp="prmw329zua4t">
      <circle cx="12" cy="12" r="2.4" data-id="element-214" data-mp="pps639jv7rtv" />
      <path d="M7.8 7.8a6 6 0 0 0 0 8.4" data-id="element-215" data-mp="kttms0de900b" />
      <path d="M16.2 16.2a6 6 0 0 0 0-8.4" data-id="element-216" data-mp="kss357ibb56z" />
      <path d="M4.9 4.9a10 10 0 0 0 0 14.2" data-id="element-217" data-mp="1i8z7k18v5n6v" />
      <path d="M19.1 19.1a10 10 0 0 0 0-14.2" data-id="element-218" data-mp="1i9qqocl9xsg9" />
    </svg>;
}
export function HandshakeIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-219" data-mp="37pt8rj5u04vn">
      <path d="m2.5 12.5 4-4 3.2 2.6a2 2 0 0 0 2.5 0l1.3-1" data-id="element-220" data-mp="37rnxz9o4yj5j" />
      <path d="M21.5 12.5 17 8l-3.1 1.9" data-id="element-221" data-mp="3cnmhaiulxaz3" />
      <path d="m9.5 13.5 2 2" data-id="element-222" data-mp="3cqh0y85sqrrg" />
      <path d="m12 12 3 3" data-id="element-223" data-mp="2y09ruj1oil3f" />
      <path d="m14.4 10.9 3.1 3.1" data-id="element-224" data-mp="2xyynoi4bnbbs" />
      <path d="M6.5 8.5 4 6" data-id="element-225" data-mp="2xxxcmdnb2ou2" />
      <path d="M17 8l2.5-2.5" data-id="element-226" data-mp="32yb9czjgiccs" />
    </svg>;
}
export function MegaphoneIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-227" data-mp="2oyablsyhnl1j">
      <path d="M4 10v4a1.5 1.5 0 0 0 1.5 1.5H8L18 20V4L8 8.5H5.5A1.5 1.5 0 0 0 4 10Z" data-id="element-228" data-mp="2t0eym8ufljf7" />
      <path d="M18 9.5a2.5 2.5 0 0 1 0 5" data-id="element-229" data-mp="2f0vwpxs7r4bc" />
      <path d="M8 15.5V20a1.5 1.5 0 0 0 3 0v-3.2" data-id="element-230" data-mp="2f278ajrwhgd0" />
    </svg>;
}
export function CalendarIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-231" data-mp="d9j2c2nvgetj">
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" data-id="element-232" data-mp="da2cgx7a5yx0" />
      <path d="M3.5 9.5h17" data-id="element-233" data-mp="i95cg38eley4" />
      <path d="M8 3.5V6.5" data-id="element-234" data-mp="i83rn71l5e37" />
      <path d="M16 3.5V6.5" data-id="element-235" data-mp="i69hmnrur6dw" />
    </svg>;
}
export function ClockIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-236" data-mp="1xrtm9xh6y8wa">
      <circle cx="12" cy="12" r="8.5" data-id="element-237" data-mp="1xpgtep9wae4g" />
      <path d="M12 7.5V12l3 1.8" data-id="element-238" data-mp="2cgzhlacwreyw" />
    </svg>;
}
export function ArrowRightIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-239" data-mp="27ozdr6tpw1x1">
      <path d="M4 12h16" data-id="element-240" data-mp="2lgmkk0lacsu2" />
      <path d="m14 6 6 6-6 6" data-id="element-241" data-mp="2lg4c85lcmo5s" />
    </svg>;
}
export function ChevronLeftIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-242" data-mp="2gk5lwcggmw2q">
      <path d="m14.5 5.5-6.5 6.5 6.5 6.5" data-id="element-243" data-mp="2veaguuyji8ec" />
    </svg>;
}
export function ChevronRightIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-244" data-mp="2qeec2ti0qcxq">
      <path d="m9.5 5.5 6.5 6.5-6.5 6.5" data-id="element-245" data-mp="1123vx4fugd8u" />
    </svg>;
}
export function PlusIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-246" data-mp="w4kgw2bbnwfu">
      <path d="M12 5v14" data-id="element-247" data-mp="3ja5ejru6xknm" />
      <path d="M5 12h14" data-id="element-248" data-mp="3jcrofy4k0c90" />
    </svg>;
}
export function CloseIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-249" data-mp="3t94dgip5m1xf">
      <path d="m6 6 12 12" data-id="element-250" data-mp="3t9mgpza8hgeu" />
      <path d="m18 6-12 12" data-id="element-251" data-mp="1523lqhjmefa" />
    </svg>;
}
export function MenuIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-252" data-mp="30kpa4tfdx81x">
      <path d="M4 7h16" data-id="element-253" data-mp="30icmq0quy5hh" />
      <path d="M4 12h16" data-id="element-254" data-mp="35iqurisglffi" />
      <path d="M4 17h16" data-id="element-255" data-mp="35kbml0ne2k9o" />
    </svg>;
}
export function CheckIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-256" data-mp="39jkioc5wiu8e">
      <path d="m5 12.5 4.5 4.5L19 7.5" data-id="element-257" data-mp="3ebu2dagfay28" />
    </svg>;
}
export function InstagramIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-258" data-mp="2htfsfwvgncz9">
      <rect x="3.5" y="3.5" width="17" height="17" rx="5" data-id="element-259" data-mp="2lu7zqkkrv7sw" />
      <circle cx="12" cy="12" r="4" data-id="element-260" data-mp="2ebs0816iueq7" />
      <circle cx="17" cy="7" r="0.9" fill="currentColor" stroke="none" data-id="element-261" data-mp="2eapavxoukkce" />
    </svg>;
}
export function WhatsappIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-262" data-mp="25attvc8m1v4g">
      <path d="M20.5 11.7a8.5 8.5 0 0 1-12.7 7.4L3.5 20.5l1.4-4.2A8.5 8.5 0 1 1 20.5 11.7Z" data-id="element-263" data-mp="25992fvhlesat" />
      <path d="M9.2 8.4c.3-.1.6 0 .8.3l.8 1.4c.1.3.1.6-.1.8l-.5.5a5.6 5.6 0 0 0 2.4 2.4l.5-.5c.2-.2.5-.3.8-.1l1.4.8c.3.2.4.5.3.8a2 2 0 0 1-2.4 1.2 8 8 0 0 1-5.2-5.2 2 2 0 0 1 1.2-2.4Z" data-id="element-264" data-mp="20bpnetd2mbht" />
    </svg>;
}
export function FacebookIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-265" data-mp="1lnw879rwdazr">
      <rect x="3.5" y="3.5" width="17" height="17" rx="5" data-id="element-266" data-mp="1hm16i4620vlg" />
      <path d="M15 8h-1.6A1.9 1.9 0 0 0 11.5 10v10.5" data-id="element-267" data-mp="1hjep7ctd31q1" />
      <path d="M9 12.6h5" data-id="element-268" data-mp="1cld5qqs0x0e1" />
    </svg>;
}
export function YoutubeIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-269" data-mp="17ntrhqvbsnm3">
      <rect x="2.5" y="5.5" width="19" height="13" rx="4" data-id="element-270" data-mp="xzg4y8mo1125" />
      <path d="m10.4 9.4 4.6 2.6-4.6 2.6V9.4Z" data-id="element-271" data-mp="y22bc4xtlais" />
    </svg>;
}
export function AwardIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-272" data-mp="o2bh84d68xj8">
      <circle cx="12" cy="9" r="5.5" data-id="element-273" data-mp="t0mpwbrqd1zv" />
      <path d="m8.6 13.8-1.6 6.7 5-2.6 5 2.6-1.6-6.7" data-id="element-274" data-mp="t1o1qigklsin" />
    </svg>;
}
export function GlobeIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-275" data-mp="1gsjov2a2zzjk">
      <circle cx="12" cy="12" r="8.5" data-id="element-276" data-mp="1lnz33vc03xgi" />
      <path d="M3.5 12h17" data-id="element-277" data-mp="1lr4q9512kp9l" />
      <path d="M12 3.5c2.2 2.4 3.4 5.4 3.4 8.5S14.2 18.1 12 20.5c-2.2-2.4-3.4-5.4-3.4-8.5S9.8 5.9 12 3.5Z" data-id="element-278" data-mp="170xj3lgiiso7" />
    </svg>;
}
export function SparkIcon({
  className,
  strokeWidth
}: IconProps) {
  return <svg className={base(className)} {...common(strokeWidth)} data-id="element-279" data-mp="1zotbidz1tyf6">
      <path d="M12 3.5 13.7 9l5.5 1.7-5.5 1.7L12 18l-1.7-5.6L4.8 10.7 10.3 9 12 3.5Z" data-id="element-280" data-mp="1zn8g6m4wubg9" />
    </svg>;
}
export const serviceIconMap = {
  mic: MicIcon,
  clapperboard: ClapperboardIcon,
  presentation: PresentationIcon,
  radio: RadioIcon,
  handshake: HandshakeIcon,
  megaphone: MegaphoneIcon
};